import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import { Row, Panel, Col } from 'react-bootstrap'
import { stringLength } from '../../../../constants/management/fleets'
import { validateDate } from '../../../../util/validationFunctions'
import InputTreeSelect from '../../../../components/commons/form/InputTreeSelect'
import InputSelect from '../../../../components/commons/form/InputSelect'
import InputDatePicker from '../../../../components/commons/form/InputDatePicker'
import InputText from '../../../../components/commons/form/InputText'

class FleetsBasicInfo extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openPanelFleet: true
    }
  }

  collapsePanelFleet () {
    this.setState({ openPanelFleet: !this.state.openPanelFleet })
  }

  validateDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  render () {
    const {
      t, isReadOnly,
      actions: { organizedUnitChange, fieldFill, stateFill },
      combos: { dossierSubTypesCombo, UOTreeCombo, UOTreeComboByPermission }
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    let bar = this.props.fleetId === '-1' ? '' : ' | '
    let title = this.props.fleetId === '-1' ? '' : this.props.fleetData?.fleet?.fleetNumber || ''
    if (title.length > stringLength.TITLE) {
      title = title.substring(0, stringLength.TITLE) + '...'
    }

    return (
      <div id="fleetsBasicInfo" className="fleet-panel dossier-panel _nf" >
        <div className="header-panel fleet-panel-box" onClick={() => this.collapsePanelFleet()}>
          <div className="name-wrapper fleet-panel-box-title">
            <h4>{t(`${tKey}FLEET`)} {bar}  <span className='fleet-panel-subTitle'>{title}</span></h4>
          </div>
          <i className={this.state.openPanelFleet ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />
        </div>
        <Panel expanded={this.state.openPanelFleet} onToggle={() => {}}>
          <Panel.Collapse>
            <Row>
              <Col sm={3}>
                <Field
                  component={InputTreeSelect}
                  id="fleets_organizedUnitId"
                  name='organizedUnitId'
                  placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                  controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                  multi={false}
                  allowClear={true}
                  valueKey="value"
                  labelKey="label"
                  childrenKey="children"
                  options={this.props.fleetId === '-1' ? UOTreeComboByPermission : UOTreeCombo}
                  onInputChange={(val) => {
                    organizedUnitChange(val)
                    stateFill({ haveChanges: true })
                  }}
                  disabled={this.props.fleetId !== '-1' || isReadOnly}
                  showSearch={false}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={InputText}
                  colWidth={100}
                  id="fleets_fleetCode"
                  name='fleetCode'
                  placeholder={t(`${tKey}CODE`)}
                  controlLabel={t(`${tKey}CODE`)}
                  onInputChange={(val) => {
                    fieldFill({ fleetCode: val })
                    stateFill({ haveChanges: true })
                  }}
                  maxLength={20}
                  disabled={isReadOnly}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={InputSelect}
                  colWidth={100}
                  id="fleets_dossierSubTypeId"
                  name='dossierSubType'
                  placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                  controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                  options={dossierSubTypesCombo}
                  valueKey="id"
                  labelKey="value"
                  onInputChange={(val) => {
                    fieldFill({ dossierSubTypeId: val })
                    stateFill({ haveChanges: true })
                  }}
                  disabled={!this.props?.fleetId || isReadOnly}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={InputDatePicker}
                  colWidth={100}
                  id="fleets_renewalDate"
                  name='renewalDate'
                  placeholder={t(`${tKey}RENEWAL_DATE`)}
                  controlLabel={t(`${tKey}RENEWAL_DATE`)}
                  validate={[this.validateDate]}
                  onInputChange={(val) => {
                    fieldFill({ renewalDate: val })
                    stateFill({ haveChanges: true })
                  }}
                  disabled={isReadOnly}
                  showTodayButton={false}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <Field
                  component={InputText}
                  colWidth={100}
                  id="fleets_dossierCount"
                  name='numDossiers'
                  placeholder={t(`${tKey}NUM_DOSSIERS`)}
                  controlLabel={t(`${tKey}NUM_DOSSIERS`)}
                  disabled={true}
                />
              </Col>
              <Col sm={9}>
                <Field
                  component={InputText}
                  colWidth={100}
                  id="fleets_description"
                  name='description'
                  placeholder={t(`${tKey}DESCRIPTION`)}
                  controlLabel={t(`${tKey}DESCRIPTION`)}
                  onInputChange={(val) => {
                    fieldFill({ description: val })
                    stateFill({ haveChanges: true })
                  }}
                  type="text"
                  maxLength={60}
                  customClass = 'col-description'
                  disabled={isReadOnly}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <Field
                  component={InputDatePicker}
                  colWidth={100}
                  id="fleets_creationDate"
                  name='creationDate'
                  placeholder={t(`${tKey}CREATION_DATE`)}
                  controlLabel={t(`${tKey}CREATION_DATE`)}
                  disabled={true}
                />
              </Col>
              <Col sm={9}>
                <Field
                  component={InputText}
                  colWidth={100}
                  id="fleets_observations"
                  name='observations'
                  placeholder={t(`${tKey}OBSERVATIONS`)}
                  controlLabel={t(`${tKey}OBSERVATIONS`)}
                  onInputChange={(val) => {
                    fieldFill({ observations: val })
                    stateFill({ haveChanges: true })
                  }}
                  componentClass="textarea"
                  customClass = 'col-description'
                  resize= 'none'
                  maxLength={200}
                  disabled={isReadOnly}
                />
              </Col>
            </Row>
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}

export default FleetsBasicInfo
